import { jsx as _jsx } from "react/jsx-runtime";
import { makeStyles } from 'tss-react/mui';
import CircularProgress from '@mui/material/CircularProgress';
const useStyles = makeStyles()(() => ({
    progress: {
        zIndex: 4,
        position: 'absolute',
        left: 0,
        top: 0,
        right: 0,
        bottom: 0,
        background: 'rgba(255, 255, 255, 0.7)',
        transition: 'opacity 0.2s ease-in',
        display: 'flex',
        verticalAlign: 'middle',
        alignItems: 'center',
        justifyContent: 'center',
    },
    fixed: {
        position: 'fixed',
    },
}));
const Loader = ({ isFixed, progressProps }) => {
    const { classes, cx } = useStyles();
    return (_jsx("div", { "data-test-locator": "Loader", className: cx(classes.progress, { [classes.fixed]: isFixed }), children: _jsx(CircularProgress, { size: 50, color: "primary", ...progressProps }) }));
};
export { Loader };
